import { useT } from '../i18n';
import { usePinFlow } from '../lib/usePinFlow';
import { useOnline } from '../lib/useOnline';
import { Dialog } from './Dialog';
import { Notice } from './Notice';
import { PinPad } from './PinPad';

/** Asks for (or creates) the caregiver PIN before showing adult-only options. */
export function AdultGate({ open, onClose, onUnlocked }: { open: boolean; onClose(): void; onUnlocked(): void }) {
  const t = useT();
  const online = useOnline();
  const pin = usePinFlow({ active: open && online, onSuccess: onUnlocked });

  return (
    <Dialog open={open} onClose={onClose} title={t('adultArea')}>
      <div className="gate">
        {!online ? (
          <Notice kind="warning">{t('needOnline')}</Notice>
        ) : pin.stage === 'loading' ? (
          <p className="muted">{t('loading')}</p>
        ) : pin.stage === 'error' ? (
          <button type="button" className="btn btn--secondary" onClick={() => void pin.retry()}>
            {t('retry')}
          </button>
        ) : (
          <>
            {pin.stage === 'create' && <p>{t('createPinIntro')}</p>}
            <PinPad
              label={pin.stage === 'create' ? (pin.confirming ? t('repeatPin') : t('newPin')) : t('enterPin')}
              submitLabel={t('confirmPin')}
              busy={pin.busy}
              onSubmit={(value) => void pin.submit(value)}
            />
          </>
        )}
        {pin.error && <Notice kind="error">{pin.error}</Notice>}
      </div>
    </Dialog>
  );
}
